@if (stream$ | async; as stream) {
    <h1 mat-dialog-title>Add Review</h1>
    <div mat-dialog-content>
        <form [formGroup]="form" class="flex column align-items-stretch">
            <div class="flex column align-space-between justify-stretch form-data">
                <mat-form-field appearance="fill">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>
                <div class="wide markdown">
                    <frog-markdown-textarea formControlName="description"></frog-markdown-textarea>
                </div>
            </div>
        </form>
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-stroked-button color="primary" [disabled]="!form.valid" (click)="save(stream.id)">
            Create
        </button>
        <button mat-stroked-button color="accent" (click)="createDaily(stream.id)" matTooltip="Create a new review with todays date as the name">
            Create Daily
        </button>
    </div>
}
